module.exports = __webpack_public_path__ + "assets/images/gender_g.ee3654af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gender_g.png
// module id = 714
// module chunks = 1